import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Το πραγματικό scrolling element (συνήθως <html> ή <body>)
    const el =
      document.scrollingElement || document.documentElement || document.body;

    // 1) Scroll στο window
    window.scrollTo(0, 0);

    // 2) Scroll και στο scrolling element (για περιπτώσεις που δεν είναι window)
    el.scrollTop = 0;

    // 3) Αν ο app container (#root) κάνει scroll, μηδένισέ το κι αυτό
    const root = document.getElementById("root");
    if (root) root.scrollTop = 0;
  }, [pathname]);

  return null;
}
